import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { getTemplateDataSources, getContainerTemplate } from './request';
import quickConfigurationModal from '../containerTemplateComponent/quickConfigurationModal.vue';
import { clickCopy } from '@/utils/public';
import tableItem from './tableItem.vue';
export default {
  components: {
    quickConfigurationModal,
    tableItem
  },
  props: {
    functionalVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeKey: 'all',
      searchMarkKey: '',
      associateDataSource: 'system',
      formatSystemData: [],
      formatDynamicData: [],
      formatFilterData: [],
      dataSource: [],
      searchTableKey: '',
      tableList: [],
      tableActiveKey: '',
      input: '',
      markList: [],
      configVisiable: false
    };
  },
  created() {
    const h = this.$createElement;
    //设置每一列的关联数据源 以及关联函数下拉数据
    const requestArr = [getTemplateDataSources({
      type: 'system'
    }), getTemplateDataSources({
      type: 'dynamic'
    }), getTemplateDataSources({
      type: 'filter'
    })];
    Promise.all(requestArr).then(res => {
      let keyMap = {}; //存储每一个末级标签的路径值
      const loop = (data, keyValue = '') => {
        return data.map(item => {
          if (item.children) {
            let key = item.mark || item.id;
            item.children = loop(item.children, keyValue ? keyValue + ',' + key : key);
            if (item.children && item.children.length == 0) {
              item.children = [{
                value: item.id + '1',
                label: '',
                name: '',
                disabledSelect: true,
                disabled: true,
                isLeaf: true
              }];
            }
            return {
              value: item.mark || item.id + '',
              label: item.name,
              name: item.name,
              id: item.id,
              children: item.children,
              isLeaf: false
            };
          } else {
            keyValue = keyValue + ',' + item.mark;
            keyMap[item.mark] = keyValue.split(',');
            // this.markDataMap[item.mark] = item.name; //快捷配置的数据源数据收集
            // this.supportSortMap[item.mark] = item.isSupportSort;
            //末级字段自定义展示
            if (item.mark) {
              return {
                value: item.mark,
                name: item.name,
                id: item.id,
                isLeaf: true,
                label: h("span", {
                  "attrs": {
                    "value": item.name
                  }
                }, [item.name, h("svg-icon", {
                  "attrs": {
                    "icon": "copy",
                    "size": 20
                  },
                  "class": "copy-icon",
                  "nativeOn": {
                    "click": e => this.copyFunction(e, item)
                  }
                })])
              };
            } else {
              return {
                value: item.mark || item.id + '',
                label: item.name,
                name: item.name,
                id: item.id,
                children: []
              };
            }
          }
        });
      };
      this.formatSystemData = loop(res[0]);
      this.formatDynamicData = loop(res[1]);
      this.formatFilterData = loop(res[2]);
      this.getTableList({});
    });
  },
  computed: {
    computedFormatSystemData() {
      if (!this.formatSystemData || !Array.isArray(this.formatSystemData)) {
        return [];
      }
      const loop = data => {
        return data && Array.isArray(data) && data.map(item => {
          if (!item.isLeaf) {
            item.children = loop(item.children);
          }
          return {
            ...item,
            label: !item.isLeaf ? this.$t(item.name) : item.label
          };
        });
      };
      let data = loop(this.formatSystemData);
      return data;
    },
    computedFormatDynamicData() {
      if (!this.formatDynamicData || !Array.isArray(this.formatDynamicData)) {
        return [];
      }
      const loop = data => {
        return data && Array.isArray(data) && data.map(item => {
          if (!item.isLeaf) {
            item.children = loop(item.children);
          }
          return {
            ...item,
            label: !item.isLeaf > 0 ? this.$t(item.name) : item.label
          };
        });
      };
      let data = loop(this.formatDynamicData);
      return data;
    },
    computedFormatFilterData() {
      if (!this.formatFilterData || !Array.isArray(this.formatFilterData)) {
        return [];
      }
      const loop = data => {
        return data && Array.isArray(data) && data.map(item => {
          if (!item.isLeaf) {
            item.children = loop(item.children);
          }
          return {
            ...item,
            label: !item.isLeaf > 0 ? this.$t(item.name) : item.label
          };
        });
      };
      let data = loop(this.formatFilterData);
      return data;
    },
    dataSourceComputed() {
      if (this.associateDataSource === 'system') {
        return this.computedFormatSystemData;
      } else if (this.associateDataSource === 'dynamic') {
        return this.computedFormatDynamicData;
      } else if (this.associateDataSource === 'filter') {
        return this.computedFormatFilterData;
      } else {
        return [];
      }
    }
  },
  methods: {
    onSearch() {
      let keyMap = {
        system: this.formatSystemData,
        dynamic: this.formatDynamicData,
        filter: this.formatFilterData
      };
      let dataCurrent = keyMap[this.associateDataSource];
      this.markList = [];
      const loop = (data, text) => {
        return data.map(item => {
          if (item !== null && item !== void 0 && item.children) {
            let parentText = text ? text + '/' + item.name : item.name;
            loop(item.children, parentText);
          } else {
            var _item$name;
            if ((item === null || item === void 0 || (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.indexOf(this.searchMarkKey)) > -1) {
              let obj = {
                mark: item.value,
                title: text,
                lastText: item.name
              };
              this.markList.push(obj);
            }
          }
        });
      };
      loop(dataCurrent);
    },
    copyFunction(e, item) {
      e.stopPropagation();
      clickCopy(item.mark);
    },
    getTableList(params) {
      getContainerTemplate(params).then(res => {
        this.tableList = res;
        // this.tableList = res.map((item, index) => {
        //   let listInfo = JSON.parse(item.listInfo);
        //   let column = [];
        //   let dataSource = [{}];
        //   if (index === 0) {
        //     this.tableActiveKey = item.mark;
        //   }
        //   if (item.tableTail == 'NO') {
        //     dataSource.push({});
        //   }
        //   if (item.autoincrement === 'YES') {
        //     column.push({
        //       title: '序号',
        //       dataIndex: 'index',
        //       key: 'index',
        //       align: 'center'
        //     });
        //     dataSource[0]['index'] = 1;
        //   }
        //   listInfo.forEach((columnItem, i) => {
        //     column.push({
        //       title: columnItem.name,
        //       dataIndex: 'column' + i,
        //       key: 'column' + i,
        //       align: 'center'
        //     });
        //     dataSource[0]['column' + i] = columnItem.mark;
        //     if (item.tableTail == 'NO' && columnItem.tail) {
        //       dataSource[1]['column' + i] = columnItem.tail + ':' + columnItem.function;
        //     }
        //   });
        //   return {
        //     name: item.name,
        //     mark: item.mark,
        //     tableHead: item.tableHead,
        //     dataSource,
        //     column
        //   };
        // });
      });
    },
    copyTableMark(e, item) {
      e.stopPropagation();
      let copyValue = '${' + item.mark + '}';
      clickCopy(copyValue);
    },
    changeTag(item) {
      this.tableActiveKey = item.mark;
    },
    tabChange(e) {
      this.activeKey = e;
      if (e === 'quickConfigurationEnter') {
        this.configVisiable = true;
      }
    },
    onMarkChange(item) {
      //选择关联数据源的标签后 更新预览区表格的标签值
      if (item.disabledSelect) {
        return;
      }
    },
    onTableSearch() {
      this.tableList = [];
      this.tableActiveKey = '';
      this.getTableList({
        mark: this.searchTableKey
      });
    },
    copyMark(item) {
      clickCopy(item.mark);
    },
    closeQuickConfiguration() {
      this.activeKey = 'all';
    }
  }
};